import React from "react";
import { cameraService } from "client-app-core";

// Material UI
import { Button, Fab as FloatingActionButton } from "@mui/material";

// Material UI Icons

import { default as HomeIcon } from "@mui/icons-material/Home";
import { NorthWest, North, NorthEast, East, SouthEast, South, SouthWest, West, Add, Remove } from "@mui/icons-material";

//import { default as NavigationArrowTopRight } from "material-ui/svg-icons/communication/call-made"; // There are no diagonal arrows
//import { default as NavigationArrowBottomLeft } from "material-ui/svg-icons/communication/call-received"; // There are no diagonal arrows

const PTZControls = ({ instanceId, camera, dock }) => {
	const handleContinuousStop = () => {
		cameraService.moveContinuous(camera.id, instanceId, 0, 0, 0);
		cameraService.moveContinuous(camera.id, instanceId, 0, 0, 0);
	};

	const handleCameraNorthWest = () => {
		// cameraService.moveRelative(this.props.camera.id, -1, -1, 1, 1);
		cameraService.moveContinuous(camera.id, instanceId, -0.5, -0.5, 0);
	};

	const handleCameraNorth = () => {
		// cameraService.moveRelative(this.props.camera.id, 0, -1, 1, 1);
		cameraService.moveContinuous(camera.id, instanceId, 0, -0.5, 0);
	};

	const handleCameraNorthEast = () => {
		// cameraService.moveRelative(this.props.camera.id, 1, -1, 1, 1);
		cameraService.moveContinuous(camera.id, instanceId, 0.5, -0.5, 0);
	};

	const handleCameraWest = () => {
		// cameraService.moveRelative(this.props.camera.id, -1, 0, 1, 1);
		cameraService.moveContinuous(camera.id, instanceId, -0.5, 0, 0);
	};

	const handleCameraHome = () => {
		cameraService.moveHome(camera.id);
	};

	const handleCameraEast = () => {
		// cameraService.moveRelative(this.props.camera.id, 1, 0, 1, 1);
		cameraService.moveContinuous(camera.id, instanceId, 0.5, 0, 0);
	};

	const handleCameraSouthWest = () => {
		// cameraService.moveRelative(this.props.camera.id, -1, 1, 1, 1);
		cameraService.moveContinuous(camera.id, instanceId, -0.5, 0.5, 0);
	};

	const handleCameraSouth = () => {
		// cameraService.moveRelative(this.props.camera.id, 0, 1, 1, 1);
		cameraService.moveContinuous(camera.id, instanceId, 0, 0.5, 0);
	};

	const handleCameraSouthEast = () => {
		// cameraService.moveRelative(this.props.camera.id, 1, 1, 1, 1);
		cameraService.moveContinuous(camera.id, instanceId, 0.5, 0.5, 0);
	};

	const handleCameraZoomIn = () => {
		cameraService.moveContinuous(camera.id, instanceId, 0, 0, 0.5);
	};

	const handleCameraZoomOut = () => {
		cameraService.moveContinuous(camera.id, instanceId, 0, 0, -0.5);
	};

	const buttonStyles = {
		zoom: {
			margin: ".5rem 1rem",
			color: "#fff",
			borderRadius: "50px",
			backgroundColor: "#828283",
			width: "35px",
			height: "30px",
			fontSize: "25px"
		},
		move: {
			width: "100%",
			height: "100%",
			minWidth: 0,
			color: "#fff",
			borderRadius: "2px"
		}
	};

	return (
		<div className="ptz-control-main-container" data-testid="ptz-controls">
			<div className="ptz-button-wrapper" data-testid="orion-components-profiles-widgets-ptzcontrols-ptz-controls-div">
				<div className="ptz-circle">
					<FloatingActionButton
						onMouseDown={handleCameraZoomIn}
						onMouseUp={handleContinuousStop}
						style={buttonStyles.zoom}
						mini={dock} data-testid="orion-components-profiles-widgets-ptzcontrols-ptz-controls-floating-action-button"
					>
						<Add />
					</FloatingActionButton>
				</div>
				<div className="ptz-circle">
					<FloatingActionButton
						onMouseDown={handleCameraZoomOut}
						onMouseUp={handleContinuousStop}
						style={buttonStyles.zoom}
						mini={dock} data-testid="orion-components-profiles-widgets-ptzcontrols-ptz-controls-floating-action-button-2"
					>
						<Remove />
					</FloatingActionButton>
				</div>
			</div>
			<div className={`ptz-grid ${dock ? "docked-grid" : ""}`}>
				<div className="ptz-grid-item" data-testid="orion-components-profiles-widgets-ptzcontrols-ptz-controls-div-2">
					<Button
						data-testid="ptz-move-up-left-button"
						variant="text"
						color="primary"
						style={{
							...buttonStyles.move,
							backgroundColor: "#828283"
						}}
						onMouseDown={handleCameraNorthWest}
						onMouseUp={handleContinuousStop}
					>
						<NorthWest />
					</Button>
				</div>
				<div className="ptz-grid-item" data-testid="orion-components-profiles-widgets-ptzcontrols-ptz-controls-div-3">
					<Button
						data-testid="ptz-move-up-button"
						variant="text"
						color="primary"
						style={{
							...buttonStyles.move,
							backgroundColor: "#828283"
						}}
						onMouseDown={handleCameraNorth}
						onMouseUp={handleContinuousStop}
					>
						<North />
					</Button>
				</div>
				<div className="ptz-grid-item" data-testid="orion-components-profiles-widgets-ptzcontrols-ptz-controls-div-4">
					<Button
						data-testid="ptz-move-up-right-button"
						variant="text"
						color="primary"
						style={{
							...buttonStyles.move,
							backgroundColor: "#828283"
						}}
						onMouseDown={handleCameraNorthEast}
						onMouseUp={handleContinuousStop}
					>
						<NorthEast />
					</Button>
				</div>
				<div className="ptz-grid-item" data-testid="orion-components-profiles-widgets-ptzcontrols-ptz-controls-div-5">
					<Button
						data-testid="ptz-move-left-button"
						variant="text"
						color="primary"
						style={{
							...buttonStyles.move,
							backgroundColor: "#828283"
						}}
						onMouseDown={handleCameraWest}
						onMouseUp={handleContinuousStop}
					>
						<West />
					</Button>
				</div>
				<div className="ptz-grid-item ptz-home" data-testid="orion-components-profiles-widgets-ptzcontrols-ptz-controls-div-6">
					<Button variant="text" color="primary" style={{ ...buttonStyles.move }} onClick={handleCameraHome} data-testid="ptz-home-button">
						<HomeIcon />
					</Button>
				</div>
				<div className="ptz-grid-item" data-testid="orion-components-profiles-widgets-ptzcontrols-ptz-controls-div-7">
					<Button
						data-testid="ptz-move-right-button"
						onMouseDown={handleCameraEast}
						onMouseUp={handleContinuousStop}
						variant="text"
						color="primary"
						style={{
							...buttonStyles.move,
							backgroundColor: "#828283"
						}}
					>
						<East />
					</Button>
				</div>

				<div className="ptz-grid-item" data-testid="orion-components-profiles-widgets-ptzcontrols-ptz-controls-div-8">
					<Button
						data-testid="ptz-move-down-left-button"
						onMouseDown={handleCameraSouthWest}
						onMouseUp={handleContinuousStop}
						variant="text"
						color="primary"
						style={{
							...buttonStyles.move,
							backgroundColor: "#828283"
						}}
					>
						<SouthWest />
					</Button>
				</div>
				<div className="ptz-grid-item" data-testid="orion-components-profiles-widgets-ptzcontrols-ptz-controls-div-9">
					<Button
						data-testid="ptz-move-down-button"
						onMouseDown={handleCameraSouth}
						onMouseUp={handleContinuousStop}
						variant="text"
						color="primary"
						style={{
							...buttonStyles.move,
							backgroundColor: "#828283"
						}}
					>
						<South />
					</Button>
				</div>
				<div className="ptz-grid-item" data-testid="orion-components-profiles-widgets-ptzcontrols-ptz-controls-div-10">
					<Button
						data-testid="ptz-move-down-right-button"
						variant="text"
						color="primary"
						style={{
							...buttonStyles.move,
							backgroundColor: "#828283"
						}}
						onMouseDown={handleCameraSouthEast}
						onMouseUp={handleContinuousStop}
					>
						<SouthEast />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default PTZControls;
